/**
 * Types of articles, from the cms like ar-content, builder, but also
 * virtuall article types rawContent which means has to be renderered client side
 *
 */

export const ar = 'ar-package';
export const external = 'external';
export const unityScene = 'unity-scene';
export const articleList = 'article-list';
export const tourList = 'tour-list';
export const rawContent = 'raw-content';
